import AmplifyWrapper from '../service/auth.service';
import { Hub } from 'aws-amplify';

export const INITIALIZE_APPLICATION = 'INITIALIZE_APPLICATION';
export const INITIALIZE_APPLICATION_SUCCESS = 'INITIALIZE_APPLICATION_SUCCESS';
export const INITIALIZE_APPLICATION_ERROR = 'INITIALIZE_APPLICATION_ERROR';

const request = () => {
	return {
		type: INITIALIZE_APPLICATION
	};
};

const recieveSuccess = user => {
	return {
		type: INITIALIZE_APPLICATION_SUCCESS,
		user
	};
};

const recieveError = errors => {
	return {
		type: INITIALIZE_APPLICATION_ERROR,
		errors
	};
};

export const initializeApplication = () => {
	//
	return async function(dispatch) {
		//
		dispatch(request());

		// Connect to hub
		Hub.listen('auth', data => {
			const { payload } = data;
			switch (payload.event) {
				case 'signIn':
					console.log('user signed in');
					break;
				case 'signOut':
					console.log('user signed out');
					break;
				case 'signUp':
					console.log('user signed up');
					break;
				case 'signIn_failure':
					console.log('user sign in failed');
					break;
				case 'configured':
					console.log('the Auth module is configured');
					break;
				default:
					console.log(data);
			}
		});

		// Check if the user is logged in
		AmplifyWrapper.currentAuthenticatedUser()
			.then(user => {
				dispatch(recieveSuccess(user));
			})
			.catch(err => {
				dispatch(recieveError(err));
			});
	};
};
